import * as React from 'react';
import Button from "@mui/material/Button";
import { useEffect, useState, useCallback } from "react";
import {
    getAllClients,
    getClientByClient_Identity,
    getClientByClientIdentity
} from "../../utilities/ClientApi";
import keycloak from "../../Keycloak";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import TableSortLabel from '@mui/material/TableSortLabel';
import { Link, TextField } from "@mui/material";
import DeleteModal from "../General/Delete";
import Box from "@mui/material/Box";
import TableContainer from '@mui/material/TableContainer';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Grid from "@mui/material/Grid";
import {useClient} from "../../utilities/ClientProvider";
import MenuItem from "@mui/material/MenuItem";


export function getStatusName(companyStatus) {
    if (companyStatus) {
        return 'Active';
    } else {
        return 'Inactive';
    }
}
export function getStatusColor(companyStatus) {
    if (companyStatus ) {
        return 'green';
    } else {
        return 'black';
    }
}

const ClientList = () => {

    const tableHeaderStyle = {
        backgroundColor: '#DDDFDF',
        height: '56px',
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#DDDFDF",
            color: theme.palette.common.black,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 15,
        },
    }));

    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
        '&:hover .MuiInput-underline:before': {
            borderBottomColor: '#FF6600', // Orange underline on hover
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#FF6600', // Underline when focused
        },
    };

    const typographyStyles = {
        backgroundColor: '#F3F3F3',
        height:'50px',
        '&:hover': {
            backgroundColor: '#F79016'
        },
    };

    const buttonStyles = {
        color: 'black',
        '&:hover': {
            color: 'white',
            backgroundColor: 'Transparent'
        },
        width:'100%',
        height: '100%',
        justifyContent: 'flex-start',
        textTransform: 'none',
    };


    const { client } = useClient(); // Get client from context
    const [clientDetails, setClientDetails] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [order, setOrder] = useState('asc');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [orderBy, setOrderBy] = useState('clientName');
    const [viewType, setViewType] = useState('active');
    const [selectedServiceRequestIndex, setSelectedServiceRequestIndex] = useState(-1);
    const [clientId, setClientId] = useState(0);
    const [harvestClientId, setHarvestClientId] = useState(0);
    const [selectedClient, setSelectedClient] =  useState(null);

    const columns = [
        { id: 'clientName', label: 'Client Harvest Name', minWidth: 200 },
        { id: 'businessName', label: 'Legal Business Name', minWidth: 200 },
        { id: 'email', label: 'Email Address', minWidth: 200},
        { id: 'companyStatus', label: 'Status', minWidth: 100 },
        { id: 'serviceRequests', label: 'Service Requests', minWidth: 75},
        { id: 'action', label: 'Action', minWidth: 100}
    ]

    const updateClientDisplay = (clients) => {
        setClientDetails(clients);
        const noClients = clients.length < 1;
        document.getElementById("NoClientText").style.display = noClients ? "block" : "none";
        document.getElementById("showClientsPaper").style.display = noClients ? "none" : "block";
    };

    const callGetAllClients = useCallback(() => {
        const fetchClients = client === "all"
            ? getAllClients(keycloak.token)
            : getClientByClientIdentity(client, keycloak.token);

        fetchClients
            .then(updateClientDisplay)
            .catch((e) => {
                console.log(e);
            });
    }, [client]);

    const callGetClientById = useCallback(() => {
        getClientByClient_Identity(keycloak.token)
            .then(updateClientDisplay)
            .catch((e) => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        if(keycloak.hasResourceRole("client_admin")){
            callGetClientById();
        }else{
            callGetAllClients();
        }
    }, [callGetAllClients, callGetClientById])

    const handleClick = (event, client) => {
        setAnchorEl(event.currentTarget);
        setSelectedClient(client);
        setClientId(client.clientId);
        setHarvestClientId(client.timeTrackingClient);
        localStorage.setItem('selectedClientName', client.clientName);
        localStorage.setItem('serviceRequestCount', (Array.isArray(client.serviceRequestDtoList) ? client.serviceRequestDtoList.length : 0).toString());
    }

    const linkHandleClick = (event, clientId, clientName, index) => {
        setSelectedServiceRequestIndex(index);
        localStorage.setItem('ClientListSelectedClientId', clientId);
        localStorage.setItem('ClientListSelectedClientName', clientName);
        localStorage.setItem('ClientListDropDownSelectedClientId', clientId);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleSortRequest = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleDelete = () =>{
        setOpenDeleteModal(true);
        document.getElementById("showClientsPaper");
    }

    const sortComparator = (a, b) => {
        if (orderBy === 'clientName') {
            return order === 'asc' ? a.clientName.localeCompare(b.clientName) : b.clientName.localeCompare(a.clientName);
        }
    };

    const viewStatus = [
        { value: "all", label: "View All" },
        { value: "active", label: "Active Service Requests" }
    ];

    return (
        <div style={{padding:"20px 5%"}} data-testid='OuterGrid'>
            <div data-testid='InnerGrid'>
                <Grid container direction={"row"} data-testid='clientListHeaderDiv' style={{marginBottom: "10px"}}>
                    <Grid item xs={1.5}>
                        <h1 data-testid='ClientHeading'>Clients</h1>
                    </Grid>
                    <Grid item xs={9.5}>
                        <TextField
                            select
                            value={viewType}
                            onChange={(event) => setViewType(event.target.value)}
                            inputProps={{
                                name: 'viewType',
                                id: 'viewType',
                            }}
                            className="activeSRDropDown"
                            variant="standard"
                            sx={style} // Apply the style object here
                            style={{ marginLeft: '10px', marginTop: '7px', width: 'auto' }}
                        >
                            {viewStatus.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={1}>
                        <Button href="ClientPage" style={{
                            float: "right",
                            backgroundColor: '#FF6600',
                            width: '89px',
                            height: '40px',
                            fontFamily: 'Poppins',
                            color: '#FFFFFF',
                        }}
                        >ADD</Button>
                    </Grid>
                </Grid>
                <div id="NoClientText" className="NoClientText" data-testid='NoClientText'>You do not have any clients.</div>
                <Box id="showClientsPaper" data-testid='showClientsPaper'>
                    <TableContainer sx={{borderRadius: "4px", boxShadow: "0px 0px 0px 1px #E0E0E0"}}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead data-testid='tableHead'>
                                <TableRow style={tableHeaderStyle}>
                                    <StyledTableCell
                                        key={columns[0].id}
                                        align={columns[0].align}
                                        style={{ minWidth: columns[0].minWidth }}
                                        sortDirection={orderBy === columns[0].id ? order : false}
                                    >
                                        <TableSortLabel
                                            active={orderBy === columns[0].id}
                                            direction={orderBy === columns[0].id ? order : 'asc'}
                                            onClick={() => handleSortRequest(columns[0].id)}
                                        >
                                            {columns[0].label}
                                        </TableSortLabel>
                                    </StyledTableCell>
                                    {columns.slice(1).map((column) => (
                                        column.id === 'serviceRequests' || column.id === 'action' ?
                                            (
                                                <StyledTableCell
                                                    key={column.id}
                                                    align={"center"}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </StyledTableCell>
                                            )
                                            : (
                                                <StyledTableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </StyledTableCell>
                                            )
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody data-testid='tableBody'>
                                {clientDetails.filter(client => viewType === 'all' || (viewType === 'active' && client.companyStatus))
                                    .sort(sortComparator).map((client, index) => (
                                        <TableRow key={index} style ={ index % 2? { background : "rgba(248, 248, 248, 0.50)" }:{ background : "#FFFFFF" }}>
                                            <TableCell align="left">{client.clientName}</TableCell>
                                            <TableCell align="left">{client.businessName}</TableCell>
                                            <TableCell align="left">{client.keyContact}</TableCell>
                                            <TableCell align="left" style={{ color: getStatusColor(client.companyStatus) }}>{getStatusName(client.companyStatus)}</TableCell>
                                            <TableCell align="center">
                                                {client.serviceRequestDtoList && viewType === 'active' ? (
                                                    <Link
                                                        href={`/ServiceRequestList?clientId=${client.clientId}`}
                                                        style={{color: '#FF6600',
                                                            textDecoration: "none",
                                                            backgroundColor: selectedServiceRequestIndex === index ? 'blue' : 'transparent',
                                                            padding: '5px',
                                                            borderRadius: '5px',
                                                        }}
                                                        onClick={(event) => linkHandleClick(event, client.clientId, client.clientName)}
                                                    >
                                                        {client.serviceRequestDtoList}
                                                    </Link>
                                                ) : (
                                                    <span style={{color: '#EC8D2B'}}>{client.serviceRequestDtoList}</span>
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                <div>
                                                    <Button align="left" variant="text" onClick={(event) => handleClick(event, client)} style={{ color: 'black'}}>
                                                        <MoreVertOutlinedIcon />
                                                    </Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} elevation={1}  >
                        <Typography sx={ typographyStyles }>
                            <Button
                                disabled={selectedClient ? !selectedClient.clientModulesDto?.insights : false}
                                href={`/ServiceRequest?clientId=${clientId}&harvestClientId=${harvestClientId}`}
                                data-testid={"addServiceRequestAction"}
                                sx={buttonStyles}
                            >
                                Add Service Request
                            </Button>
                        </Typography>
                        <Typography sx={ typographyStyles }>
                            <Button sx={buttonStyles} data-testid={"addClientUserAction"}>Add User</Button>
                        </Typography>
                        <Typography sx={ typographyStyles }>
                            <Button href={`EditClientPage?clientId=${clientId}`} data-testid={"editClientAction"} sx={buttonStyles}>Edit</Button>
                        </Typography>
                        <Typography sx={ typographyStyles }>
                            <Button onClick={handleDelete} data-testid={"deleteClientAction"} sx={buttonStyles}>Delete</Button>
                        </Typography>
                    </Popover>
                    <DeleteModal
                        clientId={clientId}
                        open={openDeleteModal}
                        onClose={() => setOpenDeleteModal(false)}
                    />
                </Box>
            </div>
        </div>
    );
};
export default ClientList;